<template>
  <div id="rarest-day-map">
    <div
      class="mobile-header"
      v-if="$vssWidth <= 767"
    >
      <div class="mobile-header__logo">
        Я видел <br />
        редкого <br />
        пациента
      </div>
    </div>
    <svg-map
      v-else
      :videos="videos"
      @video="openVideo"
    />
    <list
      :videos="videos"
      @video="openVideo"
    />
  </div>
</template>

<script>
import SvgMap from '@/components/map';
import List from '@/components/list';

export default {
  components: {
    SvgMap,
    List,
  },
  data() {
    return {
      currentVideo: {
        id: null,
        type: null,
        hash: null,
        fullUrl: null,
      },
      videos: window.mapVideos,
    };
  },
  methods: {
    openVideo(payload) {
      // Новый блок: переход по ссылке из свойства "video" в новое окно
      const url = typeof payload === 'string' ? payload : payload && payload.video;
      if (url) {
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    },
  },
};
</script>

<style lang="scss">
#rarest-day-map {
  position: relative;
  max-width: 1280px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 767px) {
    margin-left: -16px;
    width: calc(100% + 32px);
    margin-top: 11px;
  }
}
.mobile-header {
  margin-bottom: -32px;

  &__logo {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 24px;
    padding: 32px 0 64px;
    font-family: 'Circe';
    background: url(./assets/bg-mobile.jpg) no-repeat top center;
    background-size: cover;

    &:before {
      content: '';
      background: url(./assets/logo.svg) no-repeat center center;
      background-size: 100% auto;
      width: 160px;
      height: 100px;
      margin: 0 24px 0 0;
    }
  }
}
.video {
  &__player {
    position: absolute;
    left: 0;
    right: 0;
    z-index: 6;
    top: 0;
    background: rgba(#262a3d, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 32px;
    height: 600px;

    @media (max-width: 767px) {
      padding: 16px;
      height: 100%;
    }
  }
  &__holder {
    position: relative;
    width: 100%;
    max-width: 720px;

    @media (max-width: 767px) {
      width: 100%;
    }

    iframe {
      width: 100%;
    }
  }

  &__close {
    position: absolute;
    top: -32px;
    right: -32px;
    cursor: pointer;

    @media (max-width: 767px) {
      top: -40px;
      right: 0;
    }
  }
}
</style>
